import { FC } from 'react';
import cls from './radio-two-box.module.scss';
import clsx from 'clsx';

interface IProps {
    labelFirst: string;
    labelSecond: string;
    name: string;
    value: string;
    valueFirst: string;
    valueSecond: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const RadioTwoBox: FC<IProps> = ({
    labelFirst,
    labelSecond,
    name,
    onChange,
    value,
    valueFirst,
    valueSecond,
    ...props
}) => {
    return (
        <div className={cls.container} {...props}>
            <label
                className={clsx(
                    cls.inputWrapper,
                    value === valueFirst && cls.active
                )}
                >
                <input
                    type="radio"
                    name={name}
                    value={valueFirst}
                    checked={value === valueFirst}
                    onChange={onChange}
                    className={cls.input}
                />
                <span 
                    className={cls.label}
                    >
                    {labelFirst}
                </span>
            </label>
            <label 
                className={clsx(
                    cls.inputWrapper,
                    value === valueSecond && cls.active
                )}
            >
                <input
                    type="radio"
                    name={name}
                    value={valueSecond}
                    checked={value === valueSecond}
                    onChange={onChange}
                    className={cls.input}
                />
                <span 
                    className={cls.label}
                >
                    {labelSecond}
                </span>
            </label>
        </div>
    );
};
